import React, { useEffect, useRef, useState } from 'react'
import {
  Button,
  Table,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import nxtIcn from "./assets/next-button.png";
import preIcn from "./assets/previous-button.png"
import playIcn from "./assets/play-button.png";
import vwAllIcn from "./assets/view-all-button.png";
import stoIcns from "./assets/app-store-logos.jpg";
import lkIcn from "./assets/link-icon.png";
import lkIcnBlk from "./assets/link-icon-blk.png";
import homBtn from "./assets/button-home-filled-outline.png";
import albIcn from "./assets/album-art-icon.png";
import viewPlaylistIcon from "./assets/view-playlist-icon.png";
import videojs from "video.js";
import "videojs-playlist";
import "videojs-contrib-ads";
import "videojs-ima";
import "video.js/dist/video-js.css";
import "videojs-ima/dist/videojs.ima.css";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import { getPlaylist } from "./service/featured";
import useVideoAnalytics from './hooks/useVideoAnalytics';
import { copyToClipboard, getVideoMimeType, logSkipVideo } from './helpers/globals';
import { Link } from 'react-router-dom';
import { useAuth } from './components/AuthProvider';
import Header from './components/Header';
import Footer from './components/Footer';
import PartyPassPromotionModal from './components/PartyPassPromotionModal';
import { initiatePartyPassPurchase } from './utils/partyPass';
import VideoOverlayMenu from './components/VideoOverlayMenu';
import { extractPlaylistId, generatePlaylistSlug } from './utils/urlHelpers';

const Playlist = () => {
  const videoRef = useRef(null);
  const [videos, setVideos] = useState([]);
  const [curTitle, setCurTitle] = useState("");
  const [curArtist, setcurArtist] = useState("");
  const [playlistName, setPlaylist] = useState("");
  const [playlistImg, setPlaylistImg] = useState("");
  const [isPlaylistFnd, setIsPlaylistFnd] = useState(true);
  const [modal, setModal] = useState(false);
  const [copiedTitle, setCopiedTitle] = useState("");
  const [videoUUID, setVideoUUID] = useState("");
  const [heightPlr, setHeightPle] = useState("");
  const [heightDiv, setHeightDiv] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const [showMaxSkipWarning, setShowMaxSkipWarning] = useState(false);
  const [playlistSearchTerm, setPlaylistSearchTerm] = useState("");
  const [showPlaylistMenu, setShowPlaylistMenu] = useState(false);
  const [showSkipOverlay, setShowSkipOverlay] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [videoProgress, setVideoProgress] = useState(0);
  const overlayTimerRef = useRef(null);
  const mouseMoveTimerRef = useRef(null);

  const analytics = useVideoAnalytics();
  const { preventGuestAccess, hasPartyPass } = useAuth();

  const toggle = () => setModal(!modal);

  const changeTitle = (title) => {
    setModal(!modal);
    setCopiedTitle(title);
  };

  // Video skip overlay handlers
  const handleVideoMouseEnter = () => {
    if (window.screen.width > 800 && !isFullscreen) {
      setShowSkipOverlay(true);
    }
  };

  const handleVideoMouseLeave = () => {
    if (window.screen.width > 800 && isVideoPlaying && !isFullscreen) {
      setShowSkipOverlay(false);
    }
  };

  const handleMouseMove = () => {
    if (isFullscreen) {
      setShowSkipOverlay(true);
      // Clear existing timer
      if (mouseMoveTimerRef.current) {
        clearTimeout(mouseMoveTimerRef.current);
      }
      // Auto-hide after 2 seconds of no mouse movement
      mouseMoveTimerRef.current = setTimeout(() => {
        if (isFullscreen) {
          setShowSkipOverlay(false);
        }
      }, 2000);
    }
  };

  const handleVideoTap = (e) => {
    // Only show overlay if clicking on video element, not controls
    if (window.screen.width <= 800 &&
      (e.target.tagName === 'VIDEO' || e.target.classList.contains('video-skip-overlay'))) {
      setShowSkipOverlay(true);
      // Auto-hide after 2 seconds on mobile
      if (overlayTimerRef.current) {
        clearTimeout(overlayTimerRef.current);
      }
      overlayTimerRef.current = setTimeout(() => {
        setShowSkipOverlay(false);
      }, 2000);
    }
  };

  const handleSkipToNext = (e) => {
    e.stopPropagation();
    if (player.current) {
      const nextIndex = player.current.playlist.nextIndex();
      const nextVideo = player.current.playlist?.()?.[nextIndex];
      if (nextVideo?.meta?.id) {
        setShowSkipOverlay(false);
        const changeVideoEvent = new CustomEvent('changeVideo', { detail: { id: nextVideo.meta.id } });
        document.dispatchEvent(changeVideoEvent);
      }
    }
  };

  const handlePausePlay = (e) => {
    e.stopPropagation();
    if (player.current) {
      if (player.current.paused()) {
        player.current.play();
      } else {
        player.current.pause();
      }
    }
  };

  const handleFullscreen = (e) => {
    e.stopPropagation();
    if (player.current) {
      if (player.current.isFullscreen()) {
        player.current.exitFullscreen();
      } else {
        player.current.requestFullscreen();
      }
    }
  };

  const player = useRef(null);

  const toHHMMSS = (duration) => {
    let mm = parseInt(duration / 60);
    duration = duration % 60;
    let ss = parseInt(duration);
    if (mm < 10) {
      mm = `0${mm}`;
    }
    if (ss < 10) {
      ss = `0${ss}`;
    }
    return `${mm}:${ss}`;
  };

  const changeVideo = (id, e) => {
    const records = videos;
    records.sort((a, b) =>
      a.order > b.order ? 1 : b.order > a.order ? -1 : 0
    );
    const index = records.findIndex((video) => {
      return video.id === id;
    });

    const selectedVideo = records[index];



    if (player.current.playlist.currentItem() === index || logSkipVideo(id, 3, hasPartyPass)) {
      analytics.record();
      player.current.playlist.currentItem(index);
      player.current.play();
    } else {
      setShowMaxSkipWarning(true);
    }
  }

  const showThumbnail = (id) => {
    const img = document.getElementById(`hoverimg${id}`);
    img.style.marginTop = 25 + "px";
    img.style.visibility = "visible";
  };

  const hideThumbnail = (id) => {
    const img = document.getElementById(`hoverimg${id}`);
    img.style.visibility = "hidden";
  };

  const showAlbum = (id) => {
    const img = document.getElementById(`hoveralb${id}`);
    if (window.screen.width > 800) {
      img.style.left = window.screen.width / 3 + "px";
    }
    img.style.marginTop = 25 + "px";
    img.style.visibility = "visible";
  };

  const hideAlbum = (id) => {
    const img = document.getElementById(`hoveralb${id}`);
    img.style.visibility = "hidden";
  };

  let IsNoPlaylist = ({ children }) => {
    return !isPlaylistFnd ? children : <></>;
  };

  useEffect(() => {
    const imaOptions = {
      adTagUrl:
        "https://pubads.g.doubleclick.net/gampad/live/ads?iu=/22978710279/PlaylistPage&description_url=[placeholder]&tfcd=0&npa=0&sz=640x480&gdfp_req=1&output=vast&env=vp&unviewed_position_start=1&impl=s&correlator=",
      // disableCustomPlaybackForIOS10Plus: true,
    };
    const id = extractPlaylistId(window.location.pathname);
    let videoOrderParam = null;
    let shouldAutoplay = false;

    const queryParams = new URLSearchParams(window.location.search);
    const videoParam = queryParams.get("video");
    if (videoParam !== null) {
      videoOrderParam = parseInt(videoParam, 10);
    }
    shouldAutoplay = queryParams.get("autoplay") === "1";

    if (id) {
      getPlaylist(id)
        .then((res) => {
          setVideos(res.data.data.videos);
          setPlaylist(res.data.data.name);
          setPlaylistImg(res.data.data.image_url);

          // Update URL bar to SEO-friendly slug if not already formatted
          if (res.data.data?.name && res.data.data?.id) {
            const canonicalSlug = generatePlaylistSlug(res.data.data.name, res.data.data.id);
            const expectedPath = `/playlist/${canonicalSlug}`;
            if (window.location.pathname !== expectedPath && !window.location.pathname.includes("-playlist-")) {
              window.history.replaceState(null, "", expectedPath + window.location.search);
            }
          }

          let records = res.data.data.videos;
          records.sort((a, b) =>
            a.order > b.order ? 1 : b.order > a.order ? -1 : 0
          );

          // Find the starting video index based on the order parameter
          let startingVideoIndex = 0;
          if (videoOrderParam !== null) {
            const foundIndex = records.findIndex(video => video.order === videoOrderParam);
            if (foundIndex !== -1) {
              startingVideoIndex = foundIndex;
            }
          }

          // Set metadata for the starting video
          setCurTitle(records[startingVideoIndex].title);
          setcurArtist(records[startingVideoIndex].artist);
          setVideoUUID(records[startingVideoIndex].video_id);

          // Mark the starting video as playing
          records.forEach((video, index) => {
            video.is_playing = index === startingVideoIndex;
          });

          const urls = [];
          records.forEach((video) => {
            urls.push({
              sources: [
                { src: video.video_url, type: getVideoMimeType(video.video_url) },
              ],
              poster: video.thumbnail_url,
              meta: {
                id: video.id,
              }
            });
          });

          const videoOp = {
            controls: false,
          };
          player.current = videojs(videoRef.current, videoOp);
          const Button = videojs.getComponent("Button");
          const preBtn = new Button(player.current, {});
          preBtn.controlText("Previous");
          preBtn.addClass("vjs-visible-text");

          const preBtnDom = preBtn.el();
          preBtnDom.id = 'previous-btn';
          preBtnDom.innerHTML = `<img id='previous-btn-img' src=${preIcn} width="25%" />`;
          preBtnDom.onclick = function (e) {
            if (!player.current.el().classList.contains('vjs-waiting')) {
              // player.current.playlist?.previous?.();
              const previousIndex = player.current.playlist.previousIndex();
              const previousVideo = player.current.playlist?.()?.[previousIndex];
              const changeVideoEvent = new CustomEvent('changeVideo', { detail: { id: previousVideo?.meta?.id } });
              document.dispatchEvent(changeVideoEvent);
              // changeVideo(previousVideo?.meta?.id);
            }
          };
          player.current.getChild("ControlBar").addChild(preBtn, {}, 1);

          const nextBtn = new Button(player.current, {});
          nextBtn.controlText("Next");
          nextBtn.addClass("vjs-visible-text");

          const nextBtnDom = nextBtn.el();
          nextBtnDom.id = 'next-btn';
          nextBtnDom.innerHTML = `<img id='next-btn-img' src=${nxtIcn} width="25%" />`;
          nextBtnDom.onclick = function (e) {
            if (!player.current.el().classList.contains('vjs-waiting')) {
              // player.current.playlist?.next?.();
              const nextIndex = player.current.playlist.nextIndex();
              const nextVideo = player.current.playlist?.()?.[nextIndex];
              // changeVideo(nextVideo?.meta?.id);
              const changeVideoEvent = new CustomEvent('changeVideo', { detail: { id: nextVideo?.meta?.id } });
              document.dispatchEvent(changeVideoEvent);
            }
          };
          player.current.getChild("ControlBar").addChild(nextBtn, {}, 2);
          player.current.playlist(urls);
          player.current.playlist.autoadvance(0);

          // Start at the selected video if specified
          if (startingVideoIndex > 0 && startingVideoIndex < urls.length) {
            player.current.playlist.currentItem(startingVideoIndex);
          }

          // Auto-play if coming from popup with autoplay parameter
          if (shouldAutoplay) {
            // Use a small delay to ensure player is ready, then try to play
            // If browser blocks it, the play button will show
            setTimeout(() => {
              player.current.play().catch(() => {
                // Browser blocked autoplay - that's ok, user can click play
                console.log("Autoplay blocked by browser, waiting for user interaction");
              });
            }, 100);
          }

          player.current.on("play", () => {
            preventGuestAccess();
            setIsVideoPlaying(true);
            setShowSkipOverlay(false);
            let curInd = player.current.playlist.currentItem();
            analytics.start(records[curInd].id);
            setCurTitle(records[curInd].title);
            setcurArtist(records[curInd].artist);
            setVideoUUID(records[curInd].video_id);
            for (let i = 0; i < records.length; i++) {
              records[i].is_playing = false;
            }
            records[curInd].is_playing = true;
            setVideos([...records]);
          });
          player.current.ima(imaOptions);
          // player.current.ima.initializeAdDisplayContainer();
          // player.current.ima.requestAds();

          // let firInd = videos[0].video_url.lastIndexOf("/");
          // let ltInd = videos[0].video_url.lastIndexOf(".")
          player.current.on("pause", () => {
            setIsVideoPlaying(false);
            if (window.screen.width > 800) {
              setShowSkipOverlay(true);
            }
            analytics.pause();
          });
          player.current.on("timeupdate", () => {
            const currentTime = player.current.currentTime();
            const duration = player.current.duration();
            if (duration > 0) {
              setVideoProgress((currentTime / duration) * 100);
            }
          });
          player.current.on("ended", () => {
            setIsVideoPlaying(false);
            setShowSkipOverlay(false);
            analytics.record();
          });
          player.current.on("touchstart", (e) => {
            if (e.target.classList.contains("vjs-playing")) {
              // this.bigPlayButton.show();
              analytics.pause();
              player.current.pause();
            } else {
              player.current.play();
            }
            if (e.target.id === 'next-btn' || e.target.id === 'next-btn-img') {
              document.getElementById('next-btn')?.click?.();
            } else if (e.target.id === 'previous-btn' || e.target.id === 'previous-btn-img') {
              document.getElementById('previous-btn')?.click?.();
            }
          });
          return () => {
            player.current.dispose();
          };
        })
        .catch((e) => {
          console.log(e);
          setIsPlaylistFnd(false)
        });
    } else {
      setIsPlaylistFnd(false);
    }

    const handleScroll = () => {
      setIsSticky(window.scrollY > 15);
    };

    window.addEventListener('scroll', handleScroll);

    if (window.screen.width > 800) {
      setHeightPle(document.getElementById("featured-player").offsetHeight + "px");
      setHeightDiv(`${window.screen.height}px`);
    } else {
      setHeightPle("auto")
      setHeightDiv("auto")
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [preventGuestAccess]);

  // Spacebar pause/play handler
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.code === 'Space' && e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        handlePausePlay(e);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  // Fullscreen change handler
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isCurrentlyFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
      setIsFullscreen(isCurrentlyFullscreen);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);

  // Global mouse move handler for fullscreen mode
  useEffect(() => {
    if (isFullscreen) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('click', handleVideoTap);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('click', handleVideoTap);
      };
    }
  }, [isFullscreen]);

  useEffect(() => {
    function changeVideoEventHandler(e) {
      changeVideo(e.detail.id);
    }
    document.addEventListener('changeVideo', changeVideoEventHandler);

    return () => document.removeEventListener('changeVideo', changeVideoEventHandler);
  }, [changeVideo])

  return (
    <div style={{ backgroundColor: "black" }}>
      <div style={{ width: "100%" }}>
        <Header />
        {window.screen.width > 800 ? (
          <div style={{
            width: "85%",
            maxWidth: "1400px",
            color: "white",
            margin: "2px auto",
          }}>
            {/* <Link to={`/video/${videoUUID}`}> */}
            <h4 className="font-semibold">{curTitle}</h4>
            {/* </Link> */}
            <h6>{curArtist}</h6>
          </div>
        ) : (
          <></>
        )}
        <div className="video-con">
          <div className="player-con">
            {(window.screen.width < 800) ? (

              <div style={{
                color: "white",
                margin: "2px auto",
              }}>
                {/* <Link to={`/video/${videoUUID}`}> */}
                <h4 className="font-semibold">{curTitle}</h4>
                {/* </Link> */}
                <h6>{curArtist}</h6>
              </div>
            ) : (
              <></>
            )}
            <div
              className={`v video-player-wrapper ${isSticky ? 'vjs-fixed-box' : ''}`}
              onMouseEnter={handleVideoMouseEnter}
              onMouseLeave={handleVideoMouseLeave}
              onMouseMove={handleMouseMove}
              onClick={handleVideoTap}
            >
              <video
                id='featured-player'
                ref={videoRef}
                className="video-js vjs-16-9 vjs-big-play-centered"
                playsInline
              />

              {/* Video Overlay Menu (Center Controls + Side Menu) */}
              <VideoOverlayMenu
                playerRef={player}
                videoId={videos.find(v => v.is_playing)?.id}
                videoUUID={videoUUID}
                videoTitle={curTitle}
                videoArtist={curArtist}
                isPlaying={isVideoPlaying}
                isFullscreen={isFullscreen}
                onPlayPause={handlePausePlay}
                onFullscreen={handleFullscreen}
                onSkip={() => {
                  if (player.current) {
                    const nextIndex = player.current.playlist.nextIndex();
                    const nextVideo = player.current.playlist?.()?.[nextIndex];
                    if (nextVideo?.meta?.id) {
                      const changeVideoEvent = new CustomEvent('changeVideo', { detail: { id: nextVideo.meta.id } });
                      document.dispatchEvent(changeVideoEvent);
                    }
                  }
                }}
                showPlayPause={true}
                showFullscreen={true}
                showSkip={true}
                showBookmark={true}
                showCopyLink={true}
                showThumbsdown={true}
                visible={showSkipOverlay || !isVideoPlaying}
                isMobile={window.screen.width <= 800}
              />

              {/* Progress Bar */}
              <div className="video-progress-bar">
                <div
                  className="video-progress-fill"
                  style={{ width: `${videoProgress}%` }}
                />
              </div>
            </div>
          </div>
          <div className='playlist-videos-con' style={{ height: heightPlr, overflowY: "auto", }}>
            {videos.length > 0 ? (
              <div style={{ width: "80%", margin: "0 auto" }}>
                {videos
                  .sort((a, b) =>
                    a.order > b.order ? 1 : b.order > a.order ? -1 : 0
                  )
                  .map((record, idx) => {
                    if (record.is_playing) {
                      return (
                        <>
                          <div className='rowSelected'
                            style={{ width: "100%", padding: "1px" }}>
                            <img src={record.thumbnail_url} alt='' width='100%' />
                            <h5 className="font-semibold"
                            >{`${record.title} (Playing)`}</h5>
                            <h6>{record.artist}</h6>
                          </div>
                          <br />
                        </>
                      )
                    } else {
                      return (
                        <div style={{ color: "#ff71ee" }}>
                          <img src={record.thumbnail_url} alt={record.title} width='100%'
                            style={{ cursor: "pointer" }}
                            onClick={changeVideo.bind(this, record.id)} />
                          <h5 className="font-semibold"
                            style={{ cursor: "pointer" }}
                            onClick={changeVideo.bind(this, record.id)}
                          >{record.title}</h5>
                          <h6>{record.artist}</h6>
                          <br />
                        </div>
                      )
                    }
                  })}
              </div>
            ) : (
              <Spinner color="warning">Loading....</Spinner>
            )}
          </div>
        </div>
      </div>


      {/* Playlist Artwork - Matching Homepage Category Style */}
      <div className="home-category-container">
        <h3 className="home-category-title">{playlistName}</h3>
        <div className="home-category-carousel">
          <div
            className="home-category-item"
            style={{ cursor: 'pointer' }}
            onClick={() => setShowPlaylistMenu(true)}
          >
            <img src={playlistImg} alt={playlistName} />
            <div className="home-category-item-info">
              <h6 className="font-semibold">{playlistName}</h6>
              <p>Playlist Artwork</p>
            </div>
          </div>
        </div>
      </div>
      <div className="img-con">
        <Link to="/allplaylists">
          <img
            className="imgBtn"
            style={{ marginTop: "45px" }}
            src={vwAllIcn}
            width="20%"
            alt="view all"
          />
        </Link>
      </div>
      {/* <div className="img-con">
        <a href="https://app.gogopix.co/gogopixtv">
          <img
            className="imgBtn"
            style={{ marginTop: "45px" }}
            src={stoIcns}
            width="30%"
            alt="get the app logo"
          />
        </a>
      </div> */}
      <Footer />
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader>Video URL copied</ModalHeader>
        <ModalBody>
          The video url titled "{copiedTitle}" has been copied to the clipboard.
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>
      <PartyPassPromotionModal
        isOpen={showMaxSkipWarning}
        toggle={() => setShowMaxSkipWarning(false)}
        onUnlockClick={initiatePartyPassPurchase}
      />

      {/* Playlist Menu Popup */}
      <Modal
        isOpen={showPlaylistMenu}
        toggle={() => setShowPlaylistMenu(false)}
        className="playlist-menu-popup"
        size="lg"
      >
        <ModalHeader toggle={() => setShowPlaylistMenu(false)}>
          {playlistName || 'Playlist'}
        </ModalHeader>
        <ModalBody className="playlist-menu-popup-body">
          {/* Playlist Artwork */}
          {playlistImg && (
            <div className="playlist-menu-artwork">
              <img
                src={playlistImg}
                alt={playlistName}
                className="playlist-menu-artwork-image"
              />
            </div>
          )}

          {/* Search Input */}
          <div className="playlist-menu-search">
            <input
              type="text"
              className="playlist-menu-search-input"
              placeholder="Search videos by artist or title..."
              value={playlistSearchTerm}
              onChange={(e) => setPlaylistSearchTerm(e.target.value)}
            />
          </div>

          {/* Vertical Video List */}
          <div className="playlist-menu-videos">
            {videos.length > 0 ? (
              videos
                .filter((record) => {
                  if (!playlistSearchTerm) return true;
                  const searchLower = playlistSearchTerm.toLowerCase();
                  return (
                    record.title.toLowerCase().includes(searchLower) ||
                    record.artist.toLowerCase().includes(searchLower)
                  );
                })
                .sort((a, b) => a.order > b.order ? 1 : b.order > a.order ? -1 : 0)
                .map((record) => (
                  <div
                    key={record.id}
                    className={`playlist-menu-video-item ${record.is_playing ? 'playing' : ''}`}
                    onClick={() => {
                      changeVideo(record.id);
                      setShowPlaylistMenu(false);
                      setPlaylistSearchTerm("");
                    }}
                  >
                    <img src={record.thumbnail_url} alt={record.title} />
                    <div className="playlist-menu-video-info">
                      <h6 className="font-semibold">{record.title}</h6>
                      <p>{record.artist}</p>
                      {record.is_playing && (
                        <span className="playing-badge">Now Playing</span>
                      )}
                    </div>
                  </div>
                ))
            ) : (
              <div className="playlist-loading">
                <Spinner color="warning">Loading....</Spinner>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Playlist;
